import { DetalhesEmenta } from "@/pages/DetalhesEmenta";
import { DisciplinasPosGraduacao } from "@/pages/PosGraduacao/Disciplinas";
import { ListarSolicitacoesPosGraduacao } from "@/pages/PosGraduacao/ListarSolicitacoesPosGraduacao";
import { SolicitacoesPosGraduacao } from "@/pages/PosGraduacao/SolicitacoesPosGraduacao";
import { ListaDissertacoesTeses } from '@/pages/PosGraduacao/ListaDissertacoesTeses';

import { Route, Routes } from "react-router-dom";
import { MenuLateral } from "@/components/shared/MenuLateral";


const AcademicoPosGraduacaoRoutes = () => {
    return (

        <div className="flex">

            <MenuLateral
                title="Pós-graduação - Acadêmico"
                menuType="feagri-posgraduacao-acad"
            />

            <div className="pl-10">
                <Routes>
                    <Route path="/dissertacoes-e-teses-agendadas" element={<ListaDissertacoesTeses />} />
                    <Route path='/disciplinas' element={<DisciplinasPosGraduacao />} />
                    <Route path='/disciplinas/programa/:ano/:cod_disci' element={<DetalhesEmenta />} />
                    <Route path='/protocolo/solicitacoes' element={<SolicitacoesPosGraduacao />} />
                    <Route path='/protocolo/solicitacoes/listar' element={<ListarSolicitacoesPosGraduacao />} />
                </Routes>
            </div>

        </div>
    );
}

export { AcademicoPosGraduacaoRoutes };